"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateKicadPcb = validateKicadPcb;
const validateKicadV6SchemaFile_1 = require("./common/validateKicadV6SchemaFile");
const constants_1 = require("./constants");
function validateKicadPcb(filename, fileContents) {
    if (!filename.endsWith('.kicad_pcb') || !fileContents.startsWith(constants_1.KicadPcbPreamble)) {
        throw new Error('Invalid kicad pcb');
    }
    return (0, validateKicadV6SchemaFile_1.validateKicadV6SchemaFile)(fileContents, false);
}
//# sourceMappingURL=boardValidate.js.map